<div class="dots">
  <span *ngFor="let i of stepsArray" [ngClass]="{ 'active': i == active }"></span>
</div>